import * as React from 'react'

import { Stack } from '~ui/components/layout/Stack'
import { Skeleton } from '~ui/components/loadingSkeletons/Skeleton'
import { getTextFontSizeInPx } from '~ui/styleGuide/fontStyles'
import { breakpoints } from '~ui/styleGuide/styles'
import { TResponsiveBreakpointsProps } from '~ui/utils/responsiveFonts'

import { Text } from '../Text/Text'

type TProps = NoChildren &
  SkeletonProps &
  TResponsiveBreakpointsProps & {
    label: string
    value: React.ReactNode
    /**
     * horizontal alignment of individual lines
     */
    alignItems?: PropsOf<typeof Stack>['alignItems']
  }

/**
 * Two lines of text – light label above the bold information (value)
 */
export const TwoLiner: React.FC<TProps> = ({
  label,
  value,
  showSkeleton = false,
  alignItems = `flex-start`,
  responsiveBreakpoints = {
    minBreakpoint: breakpoints.sm,
    maxBreakpoint: breakpoints.lg,
  },
}) => {
  return (
    <Stack direction={`column`} spacing={`extraSmall`} alignItems={alignItems}>
      <Skeleton showSkeleton={showSkeleton}>
        <Text
          lineHeight={1.2}
          contrast={`low`}
          fontStyle={`regular`}
          responsiveSize={{
            ...responsiveBreakpoints,
            minSize: getTextFontSizeInPx(`s14`),
            maxSize: getTextFontSizeInPx(`m16`),
          }}
        >
          {label}
        </Text>
      </Skeleton>
      <Skeleton showSkeleton={showSkeleton}>
        <Text
          lineHeight={1.2}
          fontStyle={`bold`}
          responsiveSize={{
            ...responsiveBreakpoints,
            minSize: getTextFontSizeInPx(`m18`),
            maxSize: getTextFontSizeInPx(`l20`),
          }}
        >
          {value}
        </Text>
      </Skeleton>
    </Stack>
  )
}
